import { Form } from '@/components';
import { COLORS, pickThemeFontStyles, pickThemeColor } from '@/theme';
import styled from 'styled-components';

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 2rem;
  gap: 2rem;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
`;

export const StyledForm = styled(Form)`
  width: 100%;
`;

export const StyledLabel = styled.span<{
  $weight?: 'NORMAL' | 'BOLD';
  $capitalize?: boolean;
}>`
  ${pickThemeFontStyles('14', '22')};
  font-weight: ${({ $weight }) => ($weight ? $weight : 'NORMAL')};
  color: ${pickThemeColor('DARK_ONYX')};
  text-align: left;
  text-transform: ${({ $capitalize }) => ($capitalize ? 'capitalize' : 'none')};
`;

export const StyledTag = styled.div`
  ${pickThemeFontStyles('14', '16', 'SEMI_BOLD')};
  text-align: start;
  width: fit-content;
  background: ${COLORS.DARK_GRAY};
  color: ${COLORS.WHITE};
  padding: 0.75rem;
  border-radius: 99em;
  height: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  span {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    width: 1rem;
    height: 1rem;
    fill: ${COLORS.WHITE};
  }
`;

export const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledList = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const StyledText = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
  text-align: left;
  display: block;
`;

export const StyledContainer = styled.div`
  display: flex;
  gap: 4rem;
`;

export const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 24rem;

  a {
    color: ${pickThemeColor('ANT_DEFAULT_ACCENT')};
  }
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('14', '22', 'BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
  text-align: left;
  display: block;
  margin-top: 1rem;
`;
